import React from "react"

const Loader = ({ text }) => {
  return (
    <div className="loader" role="status">
      <div className="loader-spinner" />
      <span>{text}</span>
    </div>
  )
}

export default Loader
